import "./ProviderCard.css"

export function ProviderCard() {

  return (
    <div className="provider-card">
      <img width={"100%"} src="/assets/images/provider-1.webp" alt="" />

      <div className="content-card">
        <div className="tag">Enfermeria</div>
        <h3>Dr. Victoria Martinez</h3>
        <p>Description</p>

        <div className="buttons">
          <button className="btn btn-third">
            <img src="/assets/icons/right-arrow.svg" alt="" />
          </button>
        </div>
      </div>
    </div>
  );
}